module.exports = __webpack_public_path__ + "media/images/icon-enterprise-candidate-match-555491662bc83d00e37012eec6833451.png";